import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getBackgroundColorOptions,
  getBorderColorOptions,
} from "../../../utils/buttonStyleHelpers";
import { getBorderRadiusOptions } from "../../../utils/imgStyleHelpers";
import { getSizingOptions } from "../../../utils/sizeStyleHelpers";
import {
  getColorOptions,
  getFontSizeOptions,
} from "../../../utils/textStyleHelpers";
import { createCardBlock } from "../../utils/layoutBlockHelpers";
import { createImageBlock } from "../../utils/mediaBlockHelpers";
import {
  createBadgeListBlock,
  createH2Block,
  createH5Block,
  createPBlock,
} from "../../utils/textBlocksHelpers";
import { getAboutUsBlockPrimaryStyleOptions } from "../constants";
import user1ImagePlaceholder from "./user_1_image_placeholder.png";
import user2ImagePlaceholder from "./user_2_image_placeholder.png";
import user3ImagePlaceholder from "./user_3_image_placeholder.png";
import user4ImagePlaceholder from "./user_4_image_placeholder.png";
import user5ImagePlaceholder from "./user_5_image_placeholder.png";
import user6ImagePlaceholder from "./user_6_image_placeholder.png";

const cards = [
  {
    image: {
      signedId: "",
      placeholder: user1ImagePlaceholder,
    },
    name: "James Carter",
    badges: ["Business Growth Coach", "12 yrs"],
    description:
      "Specialises in scaling businesses, enhancing team productivity & fostering long-term growth.",
  },
  {
    image: {
      signedId: "",
      placeholder: user2ImagePlaceholder,
    },
    name: "Sarah Mitchell",
    badges: ["Leadership Coach", "15+ yrs"],
    description:
      "Helps executives build confidence, make impactful decisions & drive organisational success.",
  },
  {
    image: {
      signedId: "",
      placeholder: user3ImagePlaceholder,
    },
    name: "Olivia Hayes",
    badges: ["Career Devt. Coach", "10+ yrs"],
    description:
      "Guides professionals in career transitions, leadership roles, executive presence, and personal branding.",
  },
  {
    image: {
      signedId: "",
      placeholder: user4ImagePlaceholder,
    },
    name: "Emily Dawson",
    badges: ["Team Dynamics Coach", "12+ yrs"],
    description:
      "Expert in improving workplace culture, enhancing collaboration & strengthening leadership within teams.",
  },
  {
    image: {
      signedId: "",
      placeholder: user5ImagePlaceholder,
    },
    name: "James Hartwell",
    badges: ["Performance Coach", "14+ yrs"],
    description:
      "Helps leaders overcome mental barriers, build resilience, enhance decision-making.",
  },
  {
    image: {
      signedId: "",
      placeholder: user6ImagePlaceholder,
    },
    name: "Daniel Brooks",
    badges: ["Entrepreneurial Coach", "13+ yrs"],
    description:
      "Assists startup founders in refining vision, managing challenges, and accelerating business growth.",
  },
];

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "AboutUsBlock3",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Meet Our Coaches",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: cards.map(card => {
        const { image, name, badges, description } = card;
        const value = [
          createImageBlock({
            signedId: image.signedId,
            placeholder: image.placeholder,
            styles: {
              borderRadius: getBorderRadiusOptions({
                defaultValue: {
                  border_left_top_radius: 16,
                  border_left_bottom_radius: 16,
                  border_right_top_radius: 16,
                  border_right_bottom_radius: 16,
                },
              }),
              sizing: getSizingOptions({
                defaultValue: {
                  width: "auto",
                  height: "22.5rem",
                  maxHeight: "none",
                  maxWidth: "none",
                  minHeight: "none",
                  minWidth: "none",
                },
              }),
            },
          }),
          createH5Block({ text: name }),
          createBadgeListBlock({
            items: badges,
            badgeStyles: {
              backgroundColor: getBackgroundColorOptions({
                defaultValue: "var(--theme-website-color-background-primary)",
              }),
            },
          }),
          createPBlock({
            text: description,
            styles: {
              fontSize: getFontSizeOptions("1.125rem"),
              color: getColorOptions("var(--theme-website-p1-color-text)"),
            },
          }),
        ];
        return createCardBlock({
          value,
          styles: {
            backgroundColor: getBackgroundColorOptions({
              defaultValue: "var(--theme-website-color-background-secondary)",
            }),
            borderColor: getBorderColorOptions({
              defaultValue: "#ffffff00",
            }),
          },
        });
      }),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getAboutUsBlockPrimaryStyleOptions(),
      },
    },
  },
};
